import { FETCH_REPORTE_FDV, FETCH_REPORTE_EXCEL_FDV} from '../actions';

export default function(state = null, action) {
  switch (action.type) {
    case FETCH_REPORTE_FDV:
      return action.payload.data;
      case FETCH_REPORTE_EXCEL_FDV:
        return action.payload.data;/*Req. 92349 ebarboza 18 06 2021*/
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Reporte.js